module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "frontMatterPage",
    attrs: {
      "id": "ack"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterTitle1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "para1",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Thank you 1,000 times over to all the people who worked incredibly hard helping put this book together:")]), _vm._v(" "), _c('p', {
    staticClass: "para1",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Elizabeth Hodson")]), _vm._v("—you’ve been with HG every step (and bite) of the way. You help make everything we put out look amazingly adorable (and taste great!). "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Jamie Goldberg")]), _vm._v("—your devotion and commitment to Hungry Girl (and guilt-free foods) is limitless. Your attention to detail: staggering. I’d say you’re my right arm, but I’m a lefty. Saying thank you doesn’t begin to express my deep appreciation for you both. "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Lynn Bettencourt")]), _vm._v("—I am so thankful for those countless hours in the kitchen, at the office, and behind the camera. To "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Lisa Friedman")]), _vm._v("—thank you for managing the book tours, and for your impeccable organization skills. "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Dana DeRuyck")]), _vm._v("—thanks to you for your creativity, chewing, testing, cooking, and researching. To "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Jennifer Curtis")]), _vm._v("—you live too far away, but we feel like you’re always there with us. Thank you for your dedication and for all you do.")]), _vm._v(" "), _c('p', {
    staticClass: "para1",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("More thank yous…")]), _vm._v(" "), _c('p', {
    staticClass: "para1",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Alison Kreuch")]), _vm._v("—thank you for handling anything and everything I throw your way. If the U.S. could harness your energy, we wouldn’t need foreign oil.")]), _vm._v(" "), _c('p', {
    staticClass: "para1",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Super-agent "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Neeti Madan")]), _vm._v("—you are the best agent ever. Hands down. Thank you.")]), _vm._v(" "), _c('p', {
    staticClass: "para1",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("To "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Matthew Shear")]), _vm._v(" and "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Jennifer Enderlin")]), _vm._v("—thank you for continuing to believe in Hungry Girl (and for the extra color pages!). "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("John Karle")]), _vm._v("—thank you for putting up with me and for taking (most of) my calls. Thank you, as well, to "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Anne Marie Tallberg")]), _vm._v(", "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("John Murphy")]), _vm._v(", and to all the rest of my friends over at St. Martin’s Press.")]), _vm._v(" "), _c('p', {
    staticClass: "para1",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Tom Fineman")]), _vm._v("—thank you for your constant support, advice, and friendship. "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Jeff Becker")]), _vm._v("—thank you for your guidance and for being such an active "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Hungry Boy")]), _vm._v(" (keep the emails coming). "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("John Vaccaro")]), _vm._v("—thank you for EVERYTHING always!")]), _vm._v(" "), _c('p', {
    staticClass: "para1",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Special thanks also to "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Debbie Puente")]), _vm._v(", "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Jack Pullan")]), _vm._v(", and "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Lisa Foiles")]), _vm._v(". And big thanks to the wonderful General Mills photography crew, as well as "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("David Witt")]), _vm._v(", "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Greg Zimprich")]), _vm._v(", "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Shelly Dvorak")]), _vm._v(", and "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Dan Stangler")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "para1",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Thanks also to "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Meri Lillien")]), _vm._v(", "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Jay Lillien")]), _vm._v(", and to the fantastic "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Lillien")]), _vm._v(" and "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Schneider families")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "para1",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("To my furry babies, "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Cookie")]), _vm._v(" and "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Jackson")]), _vm._v(", who are a constant source of happiness and comfort—much love!")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And to my 700,000+ friends, the devoted Hungry Girl subscribers—THANK YOU, THANK YOU, THANK YOU!!!!!")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d86552c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9780312556174_ack.vue
// module id = 69
// module chunks = 0